import script from "./ToastCom.vue?vue&type=script&setup=true&lang=js"
export * from "./ToastCom.vue?vue&type=script&setup=true&lang=js"

import "./ToastCom.vue?vue&type=style&index=0&id=39135856&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39135856"]])

export default __exports__